var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinFaded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:logo-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2905 1.75H3.84344C2.72617 1.75 1.75 2.55391 1.75 3.65805V24.1505C1.75 25.2607 2.72617 26.25 3.84344 26.25H24.2845C25.4078 26.25 26.25 25.2541 26.25 24.1505V3.65805C26.2566 2.55391 25.4078 1.75 24.2905 1.75ZM9.34445 22.172H5.83461V11.2591H9.34445V22.172ZM7.71094 9.59984H7.68578C6.5625 9.59984 5.83516 8.76367 5.83516 7.71695C5.83516 6.65109 6.58164 5.83461 7.73008 5.83461C8.87852 5.83461 9.58125 6.64508 9.60641 7.71695C9.60586 8.76367 8.87852 9.59984 7.71094 9.59984ZM22.172 22.172H18.6621V16.205C18.6621 14.7755 18.1513 13.7988 16.8815 13.7988C15.9113 13.7988 15.3371 14.455 15.0817 15.0943C14.986 15.324 14.9603 15.6368 14.9603 15.9562V22.172H11.4505V11.2591H14.9603V12.7777C15.4711 12.0504 16.269 11.0037 18.1256 11.0037C20.4296 11.0037 22.1725 12.5223 22.1725 15.7965L22.172 22.172Z",
    fill: "#9A9999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFaded);
export default __webpack_public_path__ + "static/media/linkedin-faded.e708038788705fde68514969d3e41409.svg";
export { ForwardRef as ReactComponent };